import type { TimeEntryGrouping } from "@common/client"
import { z } from "zod"

export const GROUPINGS = [
  "work_order",
  "aircraft",
  "day",
] as const satisfies readonly TimeEntryGrouping[]

export const groupingSchema = z.enum(GROUPINGS)

export type Grouping = z.infer<typeof groupingSchema>

export const groupChoiceSchema = z.enum([...GROUPINGS, "none"])

export const DEFAULT_GROUPING: Grouping = "work_order"

export const GROUPING_LABELS: Record<Grouping, string> = {
  work_order: "Work order",
  aircraft: "Aircraft",
  day: "Day",
}
